function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Table, Form, Button, DatePicker, Select, message, Modal, Divider, Skeleton } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import Common from './includes/Common';
import dayjs from 'dayjs';
import Moment from 'react-moment';
import moment from 'moment';
import { CheckCircleFill, CloudDownloadFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var confirm = Modal.confirm;
var AccountantCashTransactionHistory = function AccountantCashTransactionHistory(_ref) {
  var refresh = _ref.refresh,
    reloadData = _ref.reloadData;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    transactionList = _useState2[0],
    setTransactionList = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    transactionArrayData = _useState4[0],
    setTransactionArrayData = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    agentOptions = _useState6[0],
    setAgentOptions = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFormLoading = _useState8[0],
    setIsFormLoading = _useState8[1];
  var _useState9 = useState(refresh),
    _useState0 = _slicedToArray(_useState9, 2),
    isDataChanged = _useState0[0],
    setIsDataChanged = _useState0[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedTransaction = _useState10[0],
    setSelectedTransaction = _useState10[1];
  var handleTransactionApproval = function handleTransactionApproval(t) {
    setSelectedTransaction(t);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "CONFIRMEZ-VOUS ?"
      }),
      content: /*#__PURE__*/_jsx("div", {
        children: "Le d\xE9caissement du montant de ".concat(t.amount.toLocaleString('FR'), " GNF. Demande faite par l'agent ").concat(t.user.prenom, " ").concat(t.user.nom, " pour motif: ").concat(t.comment)
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "approvetransaction", {
          user_id: Common.currentUser.id,
          cash_transaction_id: t.id
        }).then(function (response) {
          if (response.data.status == 200) {
            message.success({
              content: response.data.message,
              delay: 4
            });
            setIsDataChanged(true);
            reloadData();
          } else {
            message.error({
              content: response.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.error({
            content: 'Une erreur est survenue',
            delay: 4
          });
        })["finally"](function () {});
      }
    });
  };
  var onFinish = function onFinish(values) {};
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: 'date',
    key: 'date',
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Montant"
    }),
    dataIndex: 'amount',
    key: 'amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "ENTREE/SORTIE"
    }),
    dataIndex: 'operation_type',
    key: 'operation_type',
    render: function render(type) {
      return /*#__PURE__*/_jsx("b", {
        children: type
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Cat\xE9gorie"
    }),
    dataIndex: 'expense_category',
    key: 'expense_category',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Auteur"
    }),
    dataIndex: 'user',
    key: 'user',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Commentaire"
    }),
    dataIndex: 'comment',
    key: 'comment',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "ACTION"
    }),
    dataIndex: 'action',
    key: 'action',
    render: function render(transaction) {
      return /*#__PURE__*/_jsxs("div", {
        children: [Common.currentUser.role > 2 && transaction.operation_type == 0 && transaction.status == 0 && /*#__PURE__*/_jsx(Button, {
          type: "primary",
          size: "middle",
          onClick: function onClick() {
            handleTransactionApproval(transaction);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "APPROUVER"
          })
        }), Common.currentUser.role > 2 && transaction.status == 1 && /*#__PURE__*/_jsx(Button, {
          type: "link",
          disabled: true,
          style: {
            width: '100px'
          },
          size: "middle",
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(CheckCircleFill, {
              size: 24
            })
          })
        })]
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "PIECE"
    }),
    dataIndex: 'proof',
    key: 'proof',
    render: function render(file) {
      return /*#__PURE__*/_jsx(Button, {
        type: "link",
        href: file,
        target: "_blank",
        children: /*#__PURE__*/_jsx(CloudDownloadFill, {
          size: 22
        })
      });
    }
  }];
  useEffect(function () {
    setIsDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + "getplatformusers/" + Common.currentUser.id), axios.get("".concat(Common.baseApiUrl, "getcashtransactions/").concat(Common.currentUser.id, "/").concat(moment().startOf('year').format(), "/").concat(moment().endOf('year').format()))]).then(function (response) {
      if (response[0].data.status == 200) {
        setAgentOptions(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: 'Tous les agents',
            value: 0
          }]);
        });
        response[0].data.users.filter(function (u) {
          return u.role == 401;
        }).forEach(function (u) {
          setAgentOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: u.prenom + " " + u.nom,
              value: u.id
            }]);
          });
        });
        form.setFieldsValue({
          agent_id: 0
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
      if (response[1].data.status == 200) {
        setTransactionArrayData([]);
        setTransactionList(response[1].data.reports);
        response[1].data.transactions.forEach(function (r) {
          var otype;
          switch (r.operation_type) {
            case 0:
              otype = /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#A64839'
                },
                children: "SORTIE"
              });
              break;
            case 1:
              otype = /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#39A670'
                },
                children: "ENTREE"
              });
              break;
            case 2:
              otype = /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#4C28CE'
                },
                children: "DEPOT BANQUE"
              });
              break;
          }
          setTransactionArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: r.id,
              proof: r.proof,
              date: r.created_at,
              expense_category: r.operation_type == 0 && r.expense_category != null ? r.expense_category.label : "--",
              amount: r.amount,
              operation_type: otype,
              user: "".concat(r.user.prenom, " ").concat(r.user.nom),
              comment: r.comment,
              action: r
            }]);
          });
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue ',
        delay: 4
      });
    })["finally"](function () {});
  }, [refresh, isDataChanged]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Form, {
      onFinish: onFinish,
      form: form,
      size: "large",
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "period",
              rules: [{
                required: true,
                message: 'Ce champ est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(RangePicker, {
                showTime: true,
                format: "DD/MM/YYYY HH:mm:ss",
                presets: [{
                  label: 'Hier',
                  value: dayjs().add(-1, 'd')
                }, {
                  label: "Aujourdh'hui",
                  value: dayjs().add(0, 'd')
                }]
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "agent_id",
              rules: [{
                required: true,
                message: 'Ce champ est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Select, {
                options: agentOptions
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 2,
            md: 2,
            children: /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                loading: isFormLoading,
                type: "primary",
                htmlType: "submit",
                children: /*#__PURE__*/_jsx("b", {
                  children: "RECHERCHE"
                })
              })
            })
          })]
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Table, {
              columns: cols,
              bordered: true,
              responsive: true,
              dataSource: transactionArrayData,
              size: "small"
            })
          })
        })]
      })
    })
  });
};
export default AccountantCashTransactionHistory;